import { Box } from '@chakra-ui/react';
import { PropsWithChildren, ReactNode, useEffect } from 'react';

/**
 * Lifts a nested BaseDialog (`modal`) above another one on the page.
 */
export const StackedOverParentDialogWrapper = ({ children }: PropsWithChildren): ReactNode => {
  useEffect(() => {
    const style = document.createElement('style');

    style.textContent = `
      [data-part="positioner"]:has([data-stackedOverParentDialogWrapper-dialog]),
      [data-stackedOverParentDialogWrapper-dialog] [data-part="positioner"] {
        z-index: 2000 !important;
      }
    `;

    document.head.appendChild(style);

    return () => {
      style.remove();
    };
  }, []);

  return (
    <Box position='relative' zIndex={2000} data-stackedOverParentDialogWrapper-dialog=''>
      {children}
    </Box>
  );
};
